import { render, staticRenderFns } from "./ProjBuy.vue?vue&type=template&id=d4717214"
import script from "./ProjBuy.vue?vue&type=script&lang=js"
export * from "./ProjBuy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports